module.exports = __webpack_public_path__ + "img/色.230d39b8.gif";